import { FC, useMemo } from 'react';

import AvailableStatusComponent from '../AvailableStatusComponent';
import QuantitySelectorComponent from '../QuantitySelectorComponent';

import { getRequestedLanguages } from '../../locale/languages';
import { AVAILABLE_STATUS } from '../../utils/enum/AvailableStatus';

interface Props {
    quantity: number;
    onChange: (newValue: number) => void;
    minimum: number;
    multiple: number;
    maximum?: number;
}

const ClothingQuantitySelectorComponent: FC<Props> = ({
    quantity,
    onChange,
    minimum = 1,
    multiple,
    maximum = null,
}) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);

    const availableStatus = useMemo(() => {
        if (maximum == 0) {
            return AVAILABLE_STATUS.NotAvailable;
        }
        if (maximum != null && maximum < quantity) {
            return AVAILABLE_STATUS.InsufficientQty;
        }
        return AVAILABLE_STATUS.Available;
    }, [maximum, quantity]);

    return (
        <div className="br-clothingQuantitySelector">
            <span className="label">{language.product.clothing_selector.pieces_number}</span>
            <QuantitySelectorComponent
                quantity={quantity}
                onChange={onChange}
                minimum={minimum}
                multiple={multiple}
                maximum={maximum}
            />
            <AvailableStatusComponent status={availableStatus} />
        </div>
    );
};

export default ClothingQuantitySelectorComponent;
